import * as Yup from "yup";

export const registerMemberValidationSchema = Yup.object().shape({
	email: Yup.string().email("not a valid email address").required("email address required"),
	membershipFieldValue: Yup.string().required("value required"),
	accept: Yup.bool()
		.required("The terms of service must be accepted")
		.oneOf([true], "The terms of service must be accepted."),
	blockContentAbsoluteUri: Yup.string().required("Unexpected error"),
});
